import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { IAccount, AuthenticationService } from '../services';

@Injectable()
export class LegacyEcommAccountGuard {
  constructor(
    private auth: AuthenticationService,
    private router: Router,
  ) {}

  canActivateChild(): Observable<boolean> {
    return this._canActivate();
  }

  canActivate(): Observable<boolean> {
    return this._canActivate();
  }

  private _canActivate(): Observable<boolean> {
    return this.auth.account$.pipe(
      filter((account: IAccount) => !!account.id),
      map((account: IAccount) => {
        if (account.accountTier === 'LegacyEComm') {
          // Send user to the business information page if the user doesn't have permission to that page
          // when switching between accounts.
          this.router.navigate(['/business/information/account']);
          return false;
        } else {
          return true;
        }
      }),
    );
  }
}
